import api from "../../services/api";

export type MapOrderHistoryRow = { orderID: number; orderDate: string | null; assignedTo: string | null;
  assignedDate: string | null; delayedStatus: string | null; orderStatus: string | null;
  deliveredDate: string | null; deliveredBy: string | null };
export type MapHistoryStep = { title: string; detail?: string; date?: string | null; icon: string; active: boolean };
export async function getMapOrderHistory(id: string): Promise<MapOrderHistoryRow[]> {
  if (!/^\d+$/.test(id) || Number(id) <= 0) throw new Error("Invalid order ID.");
  const response = await api.get(`/api/Order/smart-map/orders/${id}/history`);
  if (!Array.isArray(response.data?.orders)) throw new Error("Order history is unavailable.");
  return response.data.orders.filter((row: MapOrderHistoryRow) => String(row.orderID) === id);
}
export function historySteps(rows: MapOrderHistoryRow[]): MapHistoryStep[] {
  if (!rows.length) return [];
  const assignments = rows.filter(row => row.assignedTo || row.assignedDate).slice().sort((a, b) =>
    (a.assignedDate ? Date.parse(a.assignedDate) : Infinity) - (b.assignedDate ? Date.parse(b.assignedDate) : Infinity));
  const final = rows.find(row => row.orderStatus) ?? rows[0];
  const status = final.orderStatus?.toLowerCase() || "";
  return [{ title: "Order placed", date: rows[0].orderDate, icon: "pi-shopping-cart", active: true },
    ...assignments.map((row, index) => ({ title: `Assignment ${index + 1}: ${row.assignedTo || "Unknown executive"}`,
      detail: row.delayedStatus || "Status is not updated", date: row.assignedDate, icon: "pi-truck", active: true })),
    { title: final.orderStatus || "Not delivered", detail: final.deliveredBy || undefined,
      date: final.deliveredDate, icon: status.includes("cancel") || status.includes("fail") ? "pi-times-circle"
        : !status || status.includes("not delivered") ? "pi-clock" : "pi-check-circle", active: !!final.orderStatus }];
}
